var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Watch, Prop, Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { TemplateService } from "~/services/manage-service/template.service";
var EmailTemplete = /** @class */ (function (_super) {
    __extends(EmailTemplete, _super);
    function EmailTemplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.emailModel = {
            principalId: "",
            principalName: "",
            isDefault: false,
            templateName: "",
            isEnabled: "YES",
            content: "",
            type: "EMAIL"
        };
        _this.rules = {
            principalId: [
                {
                    required: true,
                    message: "请选择委托方",
                    trigger: "blur"
                }
            ],
            templateName: [
                {
                    required: true,
                    message: "请输入模板名称",
                    trigger: "blur"
                },
                {
                    min: 2,
                    max: 10,
                    message: "长度在 2 到 10 个字符",
                    trigger: "blur"
                }
            ]
        };
        _this.defaultFlag = false;
        _this.isModify = false;
        return _this;
    }
    EmailTemplete.prototype.success = function () { };
    EmailTemplete.prototype.close = function () {
        var emailFrom = this.$refs["email-form"];
        emailFrom.resetFields();
        this.emailModel.isDefault = false;
    };
    EmailTemplete.prototype.updateDataChange = function (val) {
        if (!val)
            return;
        this.isModify = true;
        this.emailModel = Object.assign({}, this.updateData);
        this.emailModel.isDefault =
            this.emailModel.isDefault === "YES" ? true : false;
    };
    /**
     * 提交新建模板按钮
     */
    EmailTemplete.prototype.submitClick = function (type) {
        var _this = this;
        var messageFrom = this.$refs["email-form"];
        messageFrom.validate(function (valid) {
            if (!valid) {
                return;
            }
            if (_this.emailModel.isDefault && _this.emailModel.isEnabled === "NO") {
                _this.$message({
                    type: "info",
                    message: "默认模板不可设为停用!"
                });
                return;
            }
            switch (type) {
                case "add":
                    _this.addTemplate();
                    break;
                case "update":
                    _this.modifyTemplate();
                    break;
            }
        });
    };
    /**
     * 新建模板
     */
    EmailTemplete.prototype.addTemplate = function () {
        var _this = this;
        var emailModel = Object.assign({}, this.emailModel);
        emailModel.isDefault = emailModel.isDefault ? "YES" : "NO";
        emailModel.principalName =
            this.principalList.find(function (v) { return v.id === emailModel.principalId; })
                .name || "";
        this.loading.state = true;
        this.templateService.createTemplate(emailModel, this.loading).subscribe(function (data) {
            _this.$message({
                type: "success",
                message: "新增模版成功!"
            });
            _this.$emit("success");
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    /**
     * 修改模板
     */
    EmailTemplete.prototype.modifyTemplate = function () {
        var _this = this;
        var emailModel = Object.assign({}, this.emailModel);
        emailModel.isDefault = this.emailModel.isDefault ? "YES" : "NO";
        emailModel.principalName =
            this.principalList.find(function (v) { return v.id === emailModel.principalId; })
                .name || "";
        this.loading.state = true;
        this.templateService.updateTemplate(emailModel, this.loading).subscribe(function (data) {
            _this.$message({
                type: "success",
                message: "修改模版成功!"
            });
            _this.$emit("success");
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(TemplateService)
    ], EmailTemplete.prototype, "templateService", void 0);
    __decorate([
        State
    ], EmailTemplete.prototype, "principalList", void 0);
    __decorate([
        Emit("success")
    ], EmailTemplete.prototype, "success", null);
    __decorate([
        Emit("close")
    ], EmailTemplete.prototype, "close", null);
    __decorate([
        Prop()
    ], EmailTemplete.prototype, "updateData", void 0);
    __decorate([
        Watch("updateData", { immediate: true })
    ], EmailTemplete.prototype, "updateDataChange", null);
    EmailTemplete = __decorate([
        Component({
            components: {}
        })
    ], EmailTemplete);
    return EmailTemplete;
}(Vue));
export default EmailTemplete;
